var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispositivoBasico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_1478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5068 21.6775H34.771",
    stroke: "#92F23B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0979 25.9255C24.2864 26.923 24.7936 27.8324 25.5431 28.517C25.6356 28.6035 25.6997 28.7159 25.7271 28.8395C25.7544 28.9631 25.7437 29.0921 25.6964 29.2095C25.649 29.3269 25.5673 29.4272 25.4618 29.4973C25.3564 29.5673 25.2322 29.6038 25.1056 29.602H18.689C18.5624 29.6038 18.4382 29.5673 18.3328 29.4973C18.2273 29.4272 18.1456 29.3269 18.0982 29.2095C18.0509 29.0921 18.0402 28.9631 18.0675 28.8395C18.0949 28.7159 18.159 28.6035 18.2515 28.517C19.0003 27.8321 19.5069 26.9228 19.6952 25.9255",
    stroke: "#92F23B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7347 18.6248H1.98053C1.56574 18.6248 1.22949 18.961 1.22949 19.3758V29.1379C1.22949 29.5527 1.56574 29.8889 1.98053 29.8889H6.7347C7.14949 29.8889 7.48574 29.5527 7.48574 29.1379V19.3758C7.48574 18.961 7.14949 18.6248 6.7347 18.6248Z",
    stroke: "#92F23B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5067 25.9222H32.6446C33.2085 25.9222 33.7493 25.6982 34.1481 25.2994C34.5468 24.9007 34.7708 24.3599 34.7708 23.796V8.81741C34.7708 8.2535 34.5468 7.71268 34.1481 7.31393C33.7493 6.91518 33.2085 6.69116 32.6446 6.69116H11.159C10.8798 6.69116 10.6034 6.74617 10.3455 6.85304C10.0876 6.95991 9.85333 7.11655 9.656 7.31401C9.45868 7.51147 9.3022 7.74588 9.1955 8.00384C9.08881 8.2618 9.03399 8.53826 9.03418 8.81741V12.4939",
    stroke: "#92F23B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73461 29.8894H15.0019C15.4011 29.8894 15.7839 29.7308 16.0661 29.4486C16.3483 29.1663 16.5069 28.7835 16.5069 28.3844V13.9994C16.5065 13.6005 16.3478 13.2181 16.0656 12.9361C15.7834 12.6542 15.4008 12.4958 15.0019 12.4958H5.12023C4.72134 12.4958 4.33875 12.6542 4.05655 12.9361C3.77435 13.2181 3.61562 13.6005 3.61523 13.9994V18.6252",
    stroke: "#92F23B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_1478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.5 0.790771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispositivoBasico);
export default __webpack_public_path__ + "static/media/dispositivoBasico.dc879cd22b8d8131dd2eb232dfd3654e.svg";
export { ForwardRef as ReactComponent };